export default __webpack_public_path__ + "/img/b6a769a915e86dbfb85bee59cbba29ec.gif";